import gql from 'graphql-tag';

export const UPLOAD_TOKEN_V2_QUERY = gql`
  query UploadTokenV2Query {
    uploadTokenV2 {
      code
      message
      httpStatus
      body {
        region
        bucket
        tmpSecretId
        tmpSecretKey
        securityToken
        expiredTime
        keyTime
      }
    }
  }
`;
